import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd'

export default {
	name: 'confirm-line-haul-connection',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			hubName: "",
			isLoadingSearch: false,
			isLoading: false,
			isDisplay: true,
			shippingid: "",
			bagno:"",
			binno:"",
			confirmclose: false,
			isDisabledOK: false,
			invalidTokenModal: false,
			invalidtokenmsg: '',
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.userid = parseInt(userdetail[0].userid, 10); 
		this.getHubName(userdetail[0].HubId);

	},
	methods: {
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.ConfirmShipmentShortageMark();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		ConfirmShipmentShortageMark() {
			this.confirmclose = true;
		},
		CloseConfirmation() {
			this.confirmclose = false;
		},
		closeBin() {
			this.isDisabledOK = true
			this.input = ({
				"currentHubId": this.hubId,
				"currentHubName":this.hubName,
				"binNumber": this.binno,
				"bagNumber": this.bagno,
				"createdBy": this.useremail,
				"statusMarkedFrom":"WEB"
			});
			if (this.userid) {
				this.input.userId = this.userid;
			  }
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'closeOpenBin',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isDisabledOK = false
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(result.data.ReturnMessage)
						this.confirmclose = false;
						this.resetForm()
					}else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.invalidTokenModal = false
						this.confirmclose = false;
					}
				}, error => {
					console.error(error)
				})
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		resetForm() {
			this.isDisabledOK = false
			this.binno="";
			this.bagno="";
			this.isLoadingSearch = false;
			this.showTable = false;
			this.$validator.reset();
			this.errors.clear();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/CloseBin/CloseBin.js